import React, { Fragment, useContext, useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import ReactEcharts from "echarts-for-react";
import { getScheduledTrips } from "../../../Services/DispatchDashboard.service";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import CustomizerContext from "../../../_helper/Customizer";

const ScheduledTrips = ({ globalCityField }) => {
  const [scheduledTrips, setScheduledTrips] = useState([]);
  const [options, setOptions] = useState({});
  const [scheduledTripsLoader, setSchedulerTripsLoader] = useState(false)
  const { mix_background_layout } =
        useContext(CustomizerContext);
  const calculatePercent = (num, den) => {
    return ((num / den) * 100).toFixed(2);
  };
  useEffect(() => {
    setSchedulerTripsLoader(true)
    const serviceCityId = globalCityField?.value?.id || null;
    let obj = {
      serviceCityId: serviceCityId,
    };

    getScheduledTrips(obj).then((result) => {
      setSchedulerTripsLoader(false)
      console.log(result, "dispatch count data");
      if (result.data) {
        setScheduledTrips(result.data);
      }
    })
  }, []);
  useEffect(() => {
    if (scheduledTrips.length == 0) return;
    const serviceCityId = globalCityField.value?.id;
    let totalTrips = 0;
    const dataObj = {};
    if (!serviceCityId) {
      scheduledTrips.forEach((element) => {
        totalTrips += Number(element.Count);
        if (!(element.PickupType in dataObj)) {
          dataObj[element.PickupType] = 0;
        }
        dataObj[element.PickupType] += Number(element.Count);
      });
    } else {
      scheduledTrips.forEach((element) => {
        if (element.ServiceCityId != serviceCityId) return;
        totalTrips += Number(element.Count);
        if (!(element.PickupType in dataObj)) {
          dataObj[element.PickupType] = 0;
        }
        dataObj[element.PickupType] += Number(element.Count);
      });
    }

    const graphData = [];

    for (let key in dataObj) {
      graphData.push({
        value: calculatePercent(dataObj[key], totalTrips),
        name: key,
      });
    }

    console.log(graphData, "graphdata");
    setOptions({
      backgroundColor: "rgba(255, 0, 0, 0)",
      tooltip: {
        trigger: "item",
      },
      legend: {
        top: "5%",
        left: "center",
      },
      title: {
        text: `Scheduled\nTrips`,
        left: "center",
        top: "center",
        textStyle: {
          color: mix_background_layout == "dark-only" ? "rgba(255, 255, 255, 0.7)" : "black"
        }
      },
      series: [
        {
          name: "Scheduled Trips",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2,
            normal: {
              label: {
                show: true,
                position: "inner",
                formatter: function (params) {
                  return params.value + "%\n";
                },
              },
              labelLine: {
                show: false,
              },
            },
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
          },
          data: graphData,
        },
      ],
    });
  }, [scheduledTrips, globalCityField.value,mix_background_layout]);
  return (
    <Fragment>
      {scheduledTripsLoader ?
        <Skeleton width={"100%"} height={"80%"}/>
        :
        <Card className="scheduled-trips">
          <CardBody>
            {Object.keys(options).length > 0 ? (
              <ReactEcharts option={options} theme={mix_background_layout == "dark-only" ? "dark" : ""}/>
            ) : (
              <div className="no-data-available">
                <span>No Data Available</span>
              </div>
            )}
          </CardBody>
        </Card>
      }
    </Fragment>
  );
};

export default ScheduledTrips;
